import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useUploadEmailTemplateImageMutation = () =>
  useTypedMutation<FormData, string>({
    mutationFn: async payload => (await ApiInstance.post("/communication/email_pictures/upload", payload, ENV.dealerBaseURL)).data.url,
    onSuccess: () => null
  });
